var _rect, _rect2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSpaceThumbnailGray = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 102,
    height: 102,
    fill: "#E5E5E5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "thumbnail-background",
    x: 0.5,
    y: 0.5,
    width: 101,
    height: 101,
    rx: 10.5,
    fill: "#505862",
    stroke: "#1E1E1E"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 90.6572,
    cy: 22,
    r: 3,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.2335,
    cy: 82.9116,
    r: 2.12955,
    transform: "rotate(135 28.2335 82.9116)",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 88.1572,
    cy: 67.5,
    r: 4.5,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.975,
    cy: 46.364,
    r: 3.05328,
    transform: "rotate(135 26.975 46.364)",
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.6572,
    cy: 13,
    r: 2,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.6571,
    cy: 61.5859,
    r: 1,
    transform: "rotate(135 58.6571 61.5859)",
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.4139,
    cy: 30.5859,
    r: 1,
    transform: "rotate(135 49.4139 30.5859)",
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.4139,
    cy: 96.5859,
    r: 1,
    transform: "rotate(135 13.4139 96.5859)",
    fill: "white"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.078,
    cy: 78.1766,
    r: 1,
    transform: "rotate(-165 69.078 78.1766)",
    fill: "white"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 91.3036,
    cy: 54.6722,
    r: 1,
    transform: "rotate(-165 91.3036 54.6722)",
    fill: "white"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.1464,
    cy: 56.4952,
    r: 1,
    transform: "rotate(-165 16.1464 56.4952)",
    fill: "white"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.4851,
    cy: 15.8284,
    r: 2,
    transform: "rotate(135 19.4851 15.8284)",
    fill: "white"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 76.485,
    cy: 94.8284,
    r: 2,
    transform: "rotate(135 76.485 94.8284)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6087 70.1803C31.3385 71.4444 31.8171 72.7599 32.0148 74.2376C32.1719 75.645 32.1481 77.0633 31.7622 78.5034C31.6732 78.8357 31.5841 79.168 31.4545 79.4301C31.2359 80.0245 30.9767 80.5487 30.6473 81.1134C30.4178 81.5268 30.1883 81.9402 29.9183 82.2834C29.7481 82.4753 29.578 82.6671 29.4079 82.859C29.0676 83.2427 28.7273 83.6264 28.2763 83.9805C27.755 84.3751 27.304 84.7291 26.7422 85.0535L21.2685 75.5729L15.7949 66.0923C16.3567 65.7679 16.8889 65.5543 17.4912 65.3002C17.9531 65.1272 18.5258 64.9838 19.0283 64.881C19.2795 64.8296 19.5307 64.7781 19.7819 64.7267C20.2142 64.6645 20.6869 64.6724 21.1597 64.6804C21.8135 64.6775 22.397 64.7151 23.0211 64.823C23.3534 64.912 23.6452 64.9308 23.9775 65.0199C25.3473 65.4463 26.6577 66.0942 27.7981 66.934C28.9789 67.8441 29.8789 68.9163 30.6087 70.1803Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.83342 42.9414L7.20429 40.9952C8.81951 40.0627 18.0411 44.1958 22.021 45.737C22.6154 45.9557 25.73 45.1874 27.6696 44.8167C28.4935 44.6219 29.4093 44.7486 30.1254 45.1779L36.1643 48.3395L17.8243 58.7408L3.72847 44.2192C3.3042 43.8088 3.41206 43.1847 3.83342 42.9414Z",
    fill: "#D5D8DD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M92.569 48.0784C92.6233 48.9834 92.5263 49.7885 92.3591 50.6341C91.8169 53.1008 77.3452 62.5797 75.1682 63.8366L38.2398 85.3444L21.6162 56.5515L46.0551 42.4417C62.8559 34.2399 80.7032 37.4193 82.9483 37.9022C83.0591 37.9318 83.2806 37.9912 83.3914 38.0209C84.3587 38.3988 85.2854 38.7065 86.0717 39.0952C90.9406 41.5277 92.4249 45.0717 92.569 48.0784Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0282 64.8811L29.4484 82.9293C29.1081 83.313 28.7679 83.6968 28.3168 84.0508L17.4912 65.3003C18.0233 65.0867 18.5258 64.9839 19.0282 64.8811Z",
    fill: "#9DA4AF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6457 64.9309L31.7547 78.9763C31.5361 79.5707 31.2769 80.0948 31.0177 80.619L21.8545 64.7478C22.438 64.7854 23.0216 64.8231 23.6457 64.9309Z",
    fill: "#9DA4AF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3173 71.2562L38.4838 85.7656L33.2939 76.7766C33.2939 76.7766 72.1793 58.8206 87.3308 46.1402C87.3308 46.1402 92.1382 50.5746 92.3598 50.6339C92.3598 50.6339 92.6582 54.3944 62.5686 71.2048",
    fill: "#B9BEC6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9154 86.8264L57.5244 72.5248L55.7941 76.9883C55.6349 77.3611 48.1749 82.6045 47.9346 82.8369L42.9877 90.0002C42.7176 90.3434 42.4476 90.6866 42.0262 90.9298C39.9006 92.438 32.4595 97.3896 32.5377 96.8762L32.9154 86.8264Z",
    fill: "#D5D8DD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5998 66.5037L36.0014 68.0039C35.3694 68.3688 34.594 68.161 34.2291 67.529L33.5804 66.4054C33.2155 65.7733 33.4232 64.9979 34.0553 64.633L36.6537 63.1328C37.2857 62.7679 38.0611 62.9757 38.426 63.6077L39.0747 64.7314C39.4396 65.3634 39.2319 66.1388 38.5998 66.5037Z",
    fill: "#67717E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3772 61.4356L44.7788 62.9358C44.1467 63.3007 43.3713 63.0929 43.0064 62.4609L42.3577 61.3373C41.9928 60.7052 42.2006 59.9298 42.8326 59.5649L45.431 58.0647C46.063 57.6998 46.8384 57.9076 47.2033 58.5396L47.8521 59.6632C48.217 60.2953 48.0092 61.0707 47.3772 61.4356Z",
    fill: "#67717E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2258 56.327L53.6274 57.8271C52.9954 58.192 52.22 57.9843 51.8551 57.3522L51.2063 56.2286C50.8414 55.5966 51.0492 54.8212 51.6812 54.4563L54.2796 52.9561C54.9117 52.5912 55.6871 52.7989 56.052 53.431L56.7007 54.5546C57.0656 55.1866 56.8578 55.962 56.2258 56.327Z",
    fill: "#67717E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M92.569 48.0784C92.6233 48.9833 92.5263 49.7884 92.3591 50.6341C90.3435 49.7378 88.5465 48.2471 87.3707 46.2106C86.0732 43.9633 85.6699 41.4807 86.0716 39.0952C90.9406 41.5277 92.4248 45.0716 92.569 48.0784Z",
    fill: "#D5D8DD"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7794 42.3839C65.5658 41.8518 65.9763 41.4275 66.3868 41.0032C67.4887 39.9925 68.5363 38.0768 77.2221 39.3356C82.3552 40.1174 74.2792 44.7801 72.6343 45.8234C72.4236 45.9451 72.2426 45.9559 72.0616 45.9668C70.854 45.8213 67.0501 45.3957 65.7794 42.3839Z",
    fill: "#67717E"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSpaceThumbnailGray);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/SpaceThumbnail-gray.def20993bfe6b25ce23624e4ae5d9892.svg";